import { POSTBACK_MACRO_NETWORK_PLACEHOLDER, TRANSLATE_PREFIX } from '../../consts';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.POSTBACK_TEMPLATES_TAB`;
const macroTranslateSegment = macro => macro.replace(/[^a-zA-Z0-9]/g, '_').toUpperCase();

/**
 * Map resolved macro (suffix applied) back to template form for stable locale keys.
 * @param {string} macro singular_macro value, possibly with partner suffix instead of placeholder
 * @param {string} postbackMacroNetworkName partner postback macro network name (empty returns macro unchanged)
 * @returns {string} macro with suffix segments replaced by the placeholder for translation key lookup
 */
export const macroForTranslationKeys = (macro, postbackMacroNetworkName) => {
    if (!postbackMacroNetworkName || !macro) return macro;
    return macro.split(postbackMacroNetworkName).join(POSTBACK_MACRO_NETWORK_PLACEHOLDER);
};

/**
 * @param {string} macro macro string used in locale key segment
 * @returns {string} full translation key for MACRO_DESCRIPTIONS
 */
export const macroDescriptionKey = macro => `${TAB_PREFIX}.MACRO_DESCRIPTIONS.${macroTranslateSegment(macro)}`;

/**
 * @param {string} macro macro string used in locale key segment
 * @returns {string} full translation key for MACRO_LABELS
 */
export const macroLabelKey = macro => `${TAB_PREFIX}.MACRO_LABELS.${macroTranslateSegment(macro)}`;
